var render = function render(){
  var _vm$profile, _vm$profile$company;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', {
    ref: "page-heading",
    staticClass: "main-header",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation_plans')))]), _c('v-row', {
    ref: "scroll-outer",
    staticClass: "upgrade",
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    ref: "scroll-inner",
    staticClass: "upgrade-wrapper",
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "billing-cycle-selector d-flex flex-column align-center ma-5"
  }, [_c('div', {
    staticClass: "wrapper font-weight-medium",
    attrs: {
      "role": "group",
      "aria-label": _vm.$t('plans_toggle_group_label')
    }
  }, [_c('button', {
    staticClass: "px-4 py-2",
    class: {
      'selected': _vm.billingCycle === 'month'
    },
    attrs: {
      "aria-pressed": String(_vm.billingCycle === 'month')
    },
    on: {
      "click": function ($event) {
        return _vm.updateBillingCycle('month');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('monthly')))]), _c('button', {
    staticClass: "px-4 py-2",
    class: {
      'selected': _vm.billingCycle === 'year'
    },
    attrs: {
      "aria-pressed": String(_vm.billingCycle === 'year')
    },
    on: {
      "click": function ($event) {
        return _vm.updateBillingCycle('year');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yearly')))])]), _c('v-chip', {
    staticClass: "billing-cycle-note mt-3",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('plans_yearly_billing_note', {
    percent: 25
  })))])], 1), _vm.view === 'plans' ? [_c('div', {
    staticClass: "pricing-table mt-4"
  }, [_c('plan-card', {
    attrs: {
      "name": _vm.$t('plans_dpp_textile_name'),
      "tagline": _vm.$t('plans_dpp_textile_tagline'),
      "price": _vm.dppTextilePrice,
      "pricePeriod": _vm.$t('plans_price_period_month'),
      "priceNote": _vm.dppTextilePriceNote,
      "quotas": _vm.dppTextileQuotas,
      "featuresTitle": _vm.$t('plans_dpp_textile_features'),
      "features": _vm.dppTextileFeatures,
      "ctaLabel": _vm.dppTextileCtaLabel,
      "ctaDisabled": _vm.isLoading && !_vm.isSubscribedToDppTextile,
      "loading": _vm.isLoading
    },
    on: {
      "cta": _vm.onDppTextileCta
    },
    scopedSlots: _vm._u([_vm.isTestPlanAvailable ? {
      key: "after-cta",
      fn: function () {
        var _vm$currentPlan;
        return [_c('v-btn', {
          staticClass: "plan-staging-cta mt-2",
          attrs: {
            "disabled": _vm.isLoading || ((_vm$currentPlan = _vm.currentPlan) === null || _vm$currentPlan === void 0 ? void 0 : _vm$currentPlan.id) === 'st-pro',
            "color": "primary",
            "text": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.upgrade('st-pro', true);
            }
          }
        }, [_vm._v("Staging only 1 day plan")])];
      },
      proxy: true
    } : null], null, true)
  }), _c('plan-card', {
    attrs: {
      "name": _vm.$t('plans_enterprise_name'),
      "tagline": _vm.$t('plans_enterprise_tagline'),
      "price": _vm.$t('custom_pricing'),
      "priceNote": _vm.$t('plans_enterprise_price_note'),
      "quotas": _vm.enterpriseQuotas,
      "featuresTitle": _vm.$t('plans_enterprise_features'),
      "features": _vm.enterpriseFeatures,
      "ctaLabel": _vm.$t('contact_us'),
      "ctaVariant": "outlined"
    },
    on: {
      "cta": _vm.onEnterpriseCta
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-center mt-4"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.showComparison
    }
  }, [_vm._v(_vm._s(_vm.$t('compare_all_features')))])], 1)] : [_c('h5', {
    ref: "comparison-heading",
    staticClass: "d-sr-only",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v(_vm._s(_vm.$t('compare_all_features')))]), _c('transition', {
    attrs: {
      "name": "comparison",
      "appear": ""
    }
  }, [_c('plan-comparison-table', {
    attrs: {
      "groups": _vm.comparisonGroups,
      "caption": _vm.$t('plans_comparison_caption'),
      "includedLabel": _vm.$t('plans_feature_included'),
      "notIncludedLabel": _vm.$t('plans_feature_not_included'),
      "dppTextileName": _vm.$t('plans_dpp_textile_name'),
      "dppTextilePrice": _vm.dppTextilePrice,
      "dppTextilePricePeriod": _vm.$t('plans_price_period_month'),
      "dppTextilePriceNote": _vm.comparisonPriceNote,
      "dppTextileCtaLabel": _vm.comparisonCtaLabel,
      "dppTextileCtaDisabled": _vm.isLoading && !_vm.isSubscribedToDppTextile,
      "loading": _vm.isLoading,
      "loadingLabel": _vm.$t('plans_price_loading'),
      "enterpriseName": _vm.$t('plans_enterprise_name'),
      "enterprisePrice": _vm.$t('custom_pricing'),
      "enterpriseCtaLabel": _vm.$t('contact_us')
    },
    on: {
      "dpp-textile-cta": _vm.onDppTextileCta,
      "enterprise-cta": _vm.onEnterpriseCta
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-center mt-4"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.showPlans
    }
  }, [_vm._v(_vm._s(_vm.$t('view_plans')))])], 1)]], 2), (_vm$profile = _vm.profile) !== null && _vm$profile !== void 0 && (_vm$profile$company = _vm$profile.company) !== null && _vm$profile$company !== void 0 && _vm$profile$company.id && _vm.isUpgradePlanOpen ? _c('checkout-dialog', {
    ref: "paddle-checkout-dialog",
    attrs: {
      "openModal": _vm.isUpgradePlanOpen,
      "selectedPlan": _vm.selectedPlan,
      "prices": _vm.prices,
      "contract": _vm.contract,
      "isYearlyPayment": _vm.billingCycle === 'year'
    },
    on: {
      "close": _vm.handleCheckoutPopupClose
    }
  }) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.contactUsDialog,
      callback: function ($$v) {
        _vm.contactUsDialog = $$v;
      },
      expression: "contactUsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "d-flex align-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('contact_us')) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": _vm.$t('close')
    },
    on: {
      "click": function ($event) {
        _vm.contactUsDialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticClass: "pt-0 px-6 pb-6 black--text"
  }, [_vm.contactFormFailed ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('contact_form_error')))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contact_us_dialog'))
    }
  })]) : _c('div', {
    staticClass: "contact-form",
    class: {
      'contact-form--loading': _vm.isContactFormLoading
    }
  }, [_vm.isContactFormLoading ? _c('div', {
    staticClass: "contact-form-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "role": "status",
      "aria-label": _vm.$t('contact_form_loading')
    }
  })], 1) : _vm._e(), _c('div', {
    key: _vm.contactFormKey,
    attrs: {
      "id": "hubspotForm"
    }
  })])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }